import { FC } from 'react';
import { IconSVG, IconSVGComponentProps } from '../IconComponent';

export const PremiumPortfolio: FC<IconSVGComponentProps> = (props) => {
    return (
        <IconSVG viewBox="0 0 15 15" {...props}>
            <path
                d="M3.82453 1.23797C3.9769 1.0856 4.18356 1 4.39904 1H7.3125H10.226C10.4414 1 10.6481 1.0856 10.8005 1.23797L14.1051 4.54258C14.4002 4.83773 14.4237 5.30852 14.1594 5.63157L7.94132 13.2314C7.61625 13.6288 7.00875 13.6288 6.68368 13.2314L0.465606 5.63157C0.201287 5.30852 0.224767 4.83773 0.51992 4.54258L3.82453 1.23797Z"
                fill="#61E3FF"
                strokeWidth="0"
            />
        </IconSVG>
    );
};
